import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { WarningCircleIcon } from 'images'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'
import GoogleProgressWizard from './ProgressWizard'

export default function GoogleErrorView({ campaign, onClose, onRetry }) {
  const { t } = useTranslation()

  const guidance = t(
    'Settings.GoogleAccess.TestCampaign.error.guidance',
    'Please try again. If the issue persists, check your Google Ads account permissions or contact support.',
  )

  return (
    <div className="test-campaign-error">
      <div className="test-campaign-error__content">
        <h4 className="modal_inner_header_title m-0 mr-3">
          {t('Settings.GoogleAccess.TestCampaign.errorTitle', 'Test Campaign')}
        </h4>

        <div className="test-campaign-error__progress">
          <GoogleProgressWizard campaign={campaign} />
        </div>

        {campaign.error && (
          <div className="test-campaign-error__message-container">
            <div className="test-campaign-error__problem">
              <div className="test-campaign-error__problem-text">
                <div className="test-campaign-error__problem-title">
                  {campaign.error.title ||
                    t('Settings.GoogleAccess.TestCampaign.error.defaultTitle', 'Error')}
                </div>
                <div>{campaign.error.message}</div>
              </div>
            </div>
            <div className="test-campaign-error__solution">
              <WarningCircleIcon width={16} height={16} />
              <span className="test-campaign-error__solution-text">{guidance}</span>
            </div>
          </div>
        )}
      </div>

      <div className="test-campaign-error__footer">
        <div className="d-flex justify-content-between w-100">
          <TransparentBgButton
            text={t('common.close', 'Close')}
            color="navy"
            onClick={onClose}
            fullWidth={false}
          />
          <SecondaryButton
            text={t('common.retry', 'Retry')}
            color="navy"
            onClick={onRetry}
            fullWidth={false}
          />
        </div>
      </div>
    </div>
  )
}

GoogleErrorView.propTypes = {
  campaign: PropTypes.shape({
    status: PropTypes.string.isRequired,
    stage: PropTypes.string,
    campaign_id: PropTypes.string,
    adset_id: PropTypes.string,
    ad_id: PropTypes.string,
    error: PropTypes.object,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
}
